import React from 'react';
import PropTypes from 'prop-types';

import FormInput from '../../../blocks/FormInput';
import StatusText from '../../../elements/StatusText';

const TextInput = (props) => {
  const { error, icon } = props;

  const inputMods = [error ? 'error' : null, icon ? 'withIcon' : null];

  return (
    <>
      <FormInput>
        {icon ? <FormInput.Icon src={icon} /> : null}
        <FormInput.Input {...props} modifiers={inputMods} />
      </FormInput>
      {error ? <StatusText modifiers={['error']}>{error}</StatusText> : null}
    </>
  );
};

TextInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  icon: PropTypes.string,
};

TextInput.defaultProps = {
  error: '',
  icon: '',
};

export default TextInput;
